import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import DashboardLayer from "../components/DashboardLayer";
import { Link } from "react-router-dom";

const Dashboard = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        <div className="d-flex justify-content-between align-items-center">
          <h6 className="">
            Welcome back, {JSON.parse(localStorage.getItem('user')).name}!
          </h6>
          <Link to="/instances" className="btn btn-success">Instances</Link>
        </div>
        <p className="mb-5">
          Here's what's happening with your WhatsApp messaging service today.
        </p>
        {/* DashboardLayer */}
        <DashboardLayer />

      </MasterLayout>
    </>
  );
};

export default Dashboard;
